import {
  BaseQuestionnaireRoute,
  selectQuestionnaireRoutes,
} from 'app/features/questionnaires/edit/routes/slice';
import lodashGet from 'lodash.get';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export default function useQuestionnaireCurrentStepState(): BaseQuestionnaireRoute {
  return lodashGet(
    useSelector(selectQuestionnaireRoutes).routes,
    useLocation().pathname?.split('/').slice(4).join('.'),
  );
}
